import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";

import LoginPage from "./Pages/Login/Login";
import AdminLogin from "./Pages/Login/AdminLogin";
import CompanyLogin from "./Pages/Login/CompanyLogin";
import CustomerLogin from "./Pages/Login/CustomerLogin";
import ResetPassword from "./Pages/Login/ResetPassword";

import HubPanel from "./Dashboard/HubPanel";
import allRoutes from "./Routes/allRoutes";
import RoleRoute from "./Routes/RoleRoute";
import ProtectedRoute from "./Routes/ProtectedRoute";

import NotFound from "./Component/Common/NotFound";
import { DOMAIN_FAVICON_MAP } from "./utils/domainFaviconMap";
import { setFavicon } from "./utils/setFavicon";
import axios from "axios";

// ✅ GLOBAL AXIOS INTERCEPTOR
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    console.log("TOKEN:", token);

    config.headers = config.headers || {};

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    config.headers["Accept"] = "application/json";

    return config;
  },
  (error) => Promise.reject(error)
);

function App() {

  // ✅ DOMAIN-BASED FAVICON
  useEffect(() => {
    const domain = window.location.hostname.replace(/^www\./, "");
    const favicon = DOMAIN_FAVICON_MAP[domain];

    if (favicon) {
      setFavicon(favicon);
    }
  }, []);

  return (
    <>
      <Toaster position="top-right" />
      <Router>
        <Routes>

          {/* ================= PUBLIC ROUTES ================= */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/company-login" element={<CompanyLogin />} />
          {/* <Route path="/customer-login" element={<CustomerLogin />} /> */}
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* ================= PROTECTED ROUTES ================= */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<HubPanel />}>

              {/* Default landing inside dashboard */}
              <Route index element={<Navigate to="/dashboard" replace />} />

              {/* All dynamic role routes */}
              {allRoutes.map((route) => (
                <Route
                  key={route.id}
                  path={route.path}
                  element={
                    <RoleRoute allowedRoles={route.roles || []}>
                      {route.component}
                    </RoleRoute>
                  }
                />
              ))}

            </Route>
          </Route>

          {/* ================= 404 ================= */}
          <Route path="*" element={<NotFound />} />

        </Routes>
      </Router>
    </>
  );
}

export default App;

// import React, { useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// import { Toaster } from "react-hot-toast";

// import LoginPage from "./Pages/Login/Login";
// import AdminLogin from "./Pages/Login/AdminLogin";
// import CompanyLogin from "./Pages/Login/CompanyLogin";
// import CustomerLogin from "./Pages/Login/CustomerLogin";
// import ResetPassword from "./Pages/Login/ResetPassword";

// import HubPanel from "./Dashboard/HubPanel";
// import allRoutes from "./Routes/allRoutes";
// import RoleRoute from "./Routes/RoleRoute";
// import ProtectedRoute from "./Routes/ProtectedRoute";

// import NotFound from "./Component/Common/NotFound";
// import { DOMAIN_FAVICON_MAP } from "./utils/domainFaviconMap";
// import { setFavicon } from "./utils/setFavicon";

// function App() {
//   // ✅ DOMAIN-BASED FAVICON
//   useEffect(() => {
//     const domain = window.location.hostname.replace(/^www\./, "");
//     const favicon = DOMAIN_FAVICON_MAP[domain];

//     if (favicon) {
//       setFavicon(favicon);
//     }
//   }, []);

//   return (
//     <>
//       <Toaster position="top-right" />
//       <Router>
//         <Routes>

//           {/* ================= PUBLIC ROUTES ================= */}
//           <Route path="/login" element={<LoginPage />} />
//           <Route path="/admin-login" element={<AdminLogin />} />
//           <Route path="/company-login" element={<CompanyLogin />} />
//           {/* <Route path="/customer-login" element={<CustomerLogin />} /> */}
//           <Route path="/reset-password" element={<ResetPassword />} />

//           {/* ================= PROTECTED ROUTES ================= */}
//           <Route element={<ProtectedRoute />}>
//             <Route path="/" element={<HubPanel />}>

//               {/* Default landing inside dashboard */}
//               <Route index element={<Navigate to="/dashboard" replace />} />

//               {/* All dynamic role routes */}
//               {allRoutes.map((route) => (
//                 <Route
//                   key={route.id}
//                   path={route.path}
//                   element={
//                     <RoleRoute allowedRoles={route.roles || []}>
//                       {route.component}
//                     </RoleRoute>
//                   }
//                 />
//               ))}

//             </Route>
//           </Route>

//           {/* ================= 404 ================= */}
//           <Route path="*" element={<NotFound />} />

//         </Routes>
//       </Router>
//     </>
//   );
// }

// export default App;



// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { Toaster } from "react-hot-toast";
// import LoginPage from "./Pages/Login/Login";
// import AdminLogin from "./Pages/Login/AdminLogin";
// import CompanyLogin from "./Pages/Login/CompanyLogin";
// import HubPanel from "./Dashboard/HubPanel";
// import allRoutes from "./Routes/allRoutes";
// import RoleRoute from "./Routes/RoleRoute";
// import CustomerLogin from "./Pages/Login/CustomerLogin";
// import { useEffect } from "react";
// import { DOMAIN_FAVICON_MAP } from "./utils/domainFaviconMap";
// import { setFavicon } from "./utils/setFavicon";
// import NotFound from "./Component/Common/NotFound";
// import ResetPassword from "./Pages/Login/ResetPassword";
// import ProtectedRoute from "./Routes/ProtectedRoute";

// function App() {

//   // const getRedirectPath = () => {
//   //   const stored = localStorage.getItem("authUserData");
//   //   if (!stored) return "/login";

//   //   const user = JSON.parse(stored);

//   //   // Map numeric roles if needed
//   //   switch (Number(user.role)) {
//   //     case 1: return "/superdashboard"; // admin
//   //     case 2: return "/dashboard";      // company
//   //     case 3: return "/empdashboard"; // agent
//   //     case 4: return "/agentdashboard";  // employee
//   //     case 5: return "/retailerdashboard"; // retailer
//   //     case 7: return "/custdashboard";
//   //     default: return "/login";
//   //   }
//   // };

//   // const ProtectedRoute = ({ children }) => {
//   //   const stored = localStorage.getItem("authUserData");
//   //   return stored ? children : <Navigate to="/login" replace />;
//   // };

//   // ✅ DOMAIN-BASED FAVICON (BEFORE LOGIN)
//   useEffect(() => {
//     const domain = window.location.hostname.replace(/^www\./, "");
//     const favicon = DOMAIN_FAVICON_MAP[domain];

//     if (favicon) {
//       setFavicon(favicon);
//     }
//   }, []);


//   return (
//     <>
//       <Toaster position="top-right" />
//       <Router>
//         <Routes>
//           {/* Public Routes */}
//           <Route path="/login" element={<LoginPage />} />
//           <Route path="/admin-login" element={<AdminLogin />} />
//           <Route path="/company-login" element={<CompanyLogin />} />
//           <Route path="/customer-login" element={<CustomerLogin />} />

//           <Route path="/reset-password" element={<ResetPassword />} />

//           {/* Protected Routes wrapped in HubPanel */}
//           <Route path="/" element={
//             <ProtectedRoute>
//               <HubPanel />
//             </ProtectedRoute>
//           }>
//             {/* Default redirect based on role */}
//             {/* <Route index element={<Navigate to={getRedirectPath()} replace />} /> */}
//             <Route index element={<Navigate to="/dashboard" replace />} />

//             {/* Map all routes */}
//             {allRoutes.map(route => (
//               <Route
//                 key={route.id}
//                 path={route.path}  // Keep leading /
//                 element={
//                   <RoleRoute allowedRoles={route.roles || []}>
//                     {route.component}
//                   </RoleRoute>
//                 }
//               />
//             ))}

//           </Route>

//           {/* 404 fallback */}
//           {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
//           <Route path="*" element={<NotFound />} />
//         </Routes>
//       </Router>
//     </>
//   );
// }

// export default App;




// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { Toaster } from "react-hot-toast";
// import AdminLogin from "./Pages/Login/AdminLogin";
// import CompanyLogin from "./Pages/Login/CompanyLogin";
// import LoginPage from "./Pages/Login/Login";
// import HubPanel from "./Dashboard/HubPanel";
// import allRoutes from "./Routes/allRoutes";
// import RoleRoute from "./Routes/RoleRoute";

// function App() {

//   const getRedirectPath = () => {
//     const stored = localStorage.getItem("authUserData");
//     if (!stored) return "/login";

//     const user = JSON.parse(stored);

//     // Return home path based on role
//     if (user.type === "admin") return "/superdashboard";
//     if (user.type === "company") return "/dashboard";

//     return "/dashboard"; 
//   };

//   const ProtectedRoute = ({ children }) => {
//     const stored = localStorage.getItem("authUserData");
//     return stored ? children : <Navigate to="/login" replace />;
//   };

//   return (
//     <>
//       <Toaster position="top-right" />

//       <Router>
//         <Routes>
//           {/* Public Routes */}
//           <Route path="/login" element={<LoginPage />} />
//           <Route path="/admin-login" element={<AdminLogin />} />
//           <Route path="/company-login" element={<CompanyLogin />} />

//           {/* Protected Routes */}
//           <Route path="/" element={<ProtectedRoute><HubPanel /></ProtectedRoute>}>
//             <Route index element={<Navigate to={getRedirectPath()} replace />} />

//             {allRoutes.map((route) => (
//               <Route
//                 key={route.id}
//                 path={route.path.replace("/", "")}
//                 element={
//                   <ProtectedRoute>
//                     <RoleRoute allowedRoles={route.roles || []}>
//                       {route.component}
//                     </RoleRoute>
//                   </ProtectedRoute>
//                 }
//               />
//             ))}

//           </Route>

//           {/* 404 → redirect to Login */}
//           <Route path="*" element={<Navigate to="/login" replace />} />
//         </Routes>
//       </Router>
//     </>
//   );
// }

// export default App;



// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { Toaster } from "react-hot-toast";
// import AdminLogin from "./Pages/Login/AdminLogin";
// import CompanyLogin from "./Pages/Login/CompanyLogin";
// import LoginPage from "./Pages/Login/Login";
// import HubPanel from "./Dashboard/HubPanel";
// import allRoutes from "./Routes/allRoutes";

// function App() {
//   return (
//     <>
//       <Toaster position="top-right" />

//       <Router>
//         <Routes>

//           {/* LOGIN PAGE WITH TABS */}
//           <Route path="/login" element={<LoginPage />} />

//           {/* ADMIN LOGIN DIRECT */}
//           <Route path="/admin-login" element={<AdminLogin />} />

//           {/* COMPANY LOGIN DIRECT */}
//           <Route path="/company-login" element={<CompanyLogin />} />

//           {/* DASHBOARD ROUTES INSIDE HUBPANEL */}
//           <Route path="/" element={<HubPanel />}>
//             <Route index element={<Navigate to="/dashboard" replace />} />

//             {allRoutes.map((route) => (
//               <Route
//                 key={route.id}
//                 path={route.path.replace("/", "")}
//                 element={route.component}
//               />
//             ))}
//           </Route>

//           {/* FALLBACK */}
//           <Route path="*" element={<Navigate to="/login" replace />} />

//         </Routes>
//       </Router>
//     </>
//   );
// }

// export default App;


// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { Toaster } from "react-hot-toast";
// import "react-toastify/dist/ReactToastify.css";

// import AdminLogin from "./Pages/Login/AdminLogin";
// import CompanyLogin from "./Pages/Login/CompanyLogin";
// import HubPanel from "./Dashboard/HubPanel";
// import allRoutes from "./Routes/allRoutes";
// import LoginPage from "./Pages/Login/Login";

// function App() {
//   return (
//     <>
//       <Toaster position="top-right" />

//       <Router>
//         <Routes>
//           {/* ADMIN LOGIN */}
//           <Route path="/login" element={<LoginPage />} />

//           {/* COMPANY LOGIN */}
//           <Route path="/company-login" element={<CompanyLogin />} />

//           {/* HUB PANEL LAYOUT */}
//           <Route path="/" element={<HubPanel />}>
//             <Route index element={<Navigate to="/dashboard" replace />} />
//             {allRoutes.map((route) => (
//               <Route
//                 key={route.id}
//                 path={route.path.replace("/", "")}
//                 element={route.component}
//               />
//             ))}
//           </Route>

//           {/* FALLBACK */}
//           <Route path="*" element={<Navigate to="/login" replace />} />
//         </Routes>
//       </Router>
//     </>
//   );
// }

// export default App;



// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { Toaster } from "react-hot-toast";
// import "react-toastify/dist/ReactToastify.css";

// import LoginPage from "./Pages/Login/Login";
// import HubPanel from "./Dashboard/HubPanel";
// import allRoutes from "./Routes/allRoutes";


// function App() {
//   return (
//     <>
//       <Toaster position="top-right" />

//       <Router>
//         {/* <div className="flex min-h-screen"> */}
//           {/* <main className="flex-1 p-4"> */}
//             <Routes>
//               <Route path="/login" element={<LoginPage />} />

//               {/* HubPanel layout */}
//               <Route path="/" element={<HubPanel />}>
//                 <Route index element={<Navigate to="/dashboard" replace />} />
//                 {allRoutes.map((route) => (
//                   <Route key={route.id} path={route.path.replace("/", "")} element={route.component} />
//                 ))}
//               </Route>

//               {/* Fallback */}
//               <Route path="*" element={<Navigate to="/login" replace />} />
//             </Routes>
//           {/* </main> */}
//         {/* </div> */}
//       </Router>
//     </>
//   );
// }

// export default App;



// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import { Toaster } from "react-hot-toast";
// import "react-toastify/dist/ReactToastify.css";

// import LoginPage from "./Pages/Login";
// import HubPanel from "./Dashboard/HubPanel";

// import Dashboard from "./Pages/Main/Dashboard";
// import EmployeeForm from "./Pages/Main/Employee/EmployeeForm";
// import Employees from "./Pages/Main/Employee/Employees";
// import AddAgentForm from "./Pages/Main/Agent/AddAgentForm";
// import Agents from "./Pages/Main/Agent/Agents";

// import EmployeeDashboard from "./Pages/Employee/Dashboard";
// import AgentDashboard from "./Pages/Main/Agent/AgentDashboard";
// import Retailers from "./Pages/Main/Agent/Retailer/Retailers";
// import RetailerDashboard from "./Pages/Main/Retailer/RetailerDashboard";
// import OperationDashboard from "./Pages/Main/Operation/Dashboard";
// import RetailerUserDashboard from "./Pages/Main/RetailerUser/RetailerUserDashboard";
// import AddRetailerForm from "./Pages/Main/Agent/Retailer/AddRetailerForm";
// import RetailerOnboarding from "./Pages/Main/Agent/Retailer/onboarding";

// import CustomerWarrantyPortal from "./Pages/Main/Customer/CustDashboard";

// import { useContext } from "react";
// import { AuthContext } from "./context/AuthContext";
// import LeadsViewPage from "./Pages/Employee/LeadsViewPage";
// import RetailersPage from "./Pages/Main/Operation/RetailersPage";
// import RetailerDetailsPage from "./Pages/Main/Operation/RetailerDetailsPage";
// import TasksView from "./Pages/Main/Operation/TasksView";
// import OpenTasksPage from "./Pages/Main/Operation/OpenTasksPage";
// import RetailersView from "./Pages/Main/Agent/Retailer/RetailersView";

// function App() {
//   const { authUser } = useContext(AuthContext);
//   const userRole = authUser?.role;

//   return (
//     <>
//       <Toaster position="top-right" />

//       <Router>
//         <Routes>

//           {/* Public Route */}
//           <Route path="/login" element={<LoginPage />} />

//           {/* ========================================== */}
//           {/* 🔥 RETAILER ROUTES — NO HUBPANEL */}
//           {/* ========================================== */}
//           {userRole === 5 && (
//             <>
//               <Route path="/retailerdashboard" element={<RetailerDashboard />} />
//               <Route path="*" element={<Navigate to="/retailerdashboard" replace />} />
//             </>
//           )}

//           {/* ========================================== */}
//           {/* 🔥 ALL OTHER ROLES — WITH HUBPANEL */}
//           {/* ========================================== */}
//           {userRole !== 5 && authUser && (
//             <Route path="/" element={<HubPanel />}>
//               <Route index element={<Navigate to="dashboard" replace />} />
//               <Route path="dashboard" element={<Dashboard />} />
//               <Route path="allemployees" element={<Employees />} />
//               <Route path="allagents" element={<Agents />} />
//               <Route path="allretailers" element={<Retailers />} />
//               <Route path="retaileronboard" element={<RetailerOnboarding />} />
//               <Route path="employeedashboard" element={<EmployeeDashboard />} />
//               <Route path="operationdashboard" element={<OperationDashboard />} />
//               <Route path="agentdashboard" element={<AgentDashboard />} />
//               <Route path="/retailerdashboard" element={<RetailerDashboard />} />
//               <Route path="userdashboard" element={<RetailerUserDashboard />} />
//               <Route path="custdashboard" element={<CustomerWarrantyPortal />} />

//               <Route path="add-employee" element={<EmployeeForm />} />
//               <Route path="add-agent" element={<AddAgentForm />} />
//               <Route path="add-retailer" element={<AddRetailerForm />} />

//               <Route path="/leads-view" element={<LeadsViewPage />} />
//               <Route path="/retailers" element={<RetailersPage />} />
//               <Route path="/retailer/:id" element={<RetailerDetailsPage />} />
//               <Route path="/tasks" element={<TasksView />} />
//               <Route path="/tasks/open" element={<OpenTasksPage />} />
//               <Route path="/agentretailers" element={<RetailersView />} />
              
//             </Route>
//           )}

//           {/* Unknown Route → Login */}
//           <Route path="*" element={<Navigate to="/login" replace />} />
//         </Routes>
//       </Router>

//       <ToastContainer position="bottom-right" />
//     </>
//   );
// }

// export default App;


// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import { Toaster } from "react-hot-toast";
// import "react-toastify/dist/ReactToastify.css";
// import LoginPage from "./Pages/Login";
// import HubPanel from "./Dashboard/HubPanel";
// import Dashboard from "./Pages/Main/Dashboard";
// import EmployeeForm from "./Pages/Main/Employee/EmployeeForm";
// import Employees from "./Pages/Main/Employee/Employees";
// import AddAgentForm from "./Pages/Main/Agent/AddAgentForm";
// import Agents from "./Pages/Main/Agent/Agents";

// import EmployeeDashboard from "./Pages/Employee/Dashboard";
// import AgentDashboard from "./Pages/Main/Agent/AgentDashboard";
// import Retailers from "./Pages/Main/Agent/Retailer/Retailers";
// import RetailerDashboard from "./Pages/Main/Retailer/RetailerDashboard";
// import OperationDashboard from "./Pages/Main/Operation/Dashboard";
// import RetailerUserDashboard from "./Pages/Main/RetailerUser/RetailerUserDashboard";
// import AddRetailerForm from "./Pages/Main/Agent/Retailer/AddRetailerForm";
// import RetailerOnboarding from "./Pages/Main/Agent/Retailer/onboarding";
// import CustomerWarrantyPortal from "./Pages/Main/Customer/CustDashboard";




// function App() {

//   const authuser = localStorage("authUserData");
//   return (
//     <>
//     <Toaster position="top-right" />
//     <Router>
//       <Routes>
        
//         {/* Login */}
//         <Route path="/login" element={<LoginPage />} />

       
//         <Route path="/" element={<HubPanel />}>
          
      
//           <Route index element={<Navigate to="/dashboard" replace />} />

//           <Route path="dashboard" element={<Dashboard />} />
//           <Route path="allemployees" element={<Employees />} />
//           <Route path="allagents" element={<Agents />} />
//           <Route path="allretailers" element={<Retailers />} />
//           <Route path="retaileronboard" element={<RetailerOnboarding />} />
//           <Route path="employeedashboard" element={<EmployeeDashboard />} />
//           <Route path="operationdashboard" element={<OperationDashboard />} />
//           <Route path="agentdashboard" element={<AgentDashboard />} />
//           <Route path="retailerdashboard" element={<RetailerDashboard />} />
//           <Route path="userdashboard" element={<RetailerUserDashboard />} />
//           <Route path="custdashboard" element={<CustomerWarrantyPortal />} />

          
//           <Route
//             path="/add-employee"
//             element={
//               <div className="mx-auto">
//                 <EmployeeForm />
//               </div>
//             }
//           />
//           <Route
//             path="/add-agent"
//             element={
//               <div className="mx-auto">
//                 <AddAgentForm />
//               </div>
//             }
//           />

//           <Route
//             path="/add-retailer"
//             element={
//               <div className="mx-auto">
//                 <AddRetailerForm />
//               </div>
//             }
//           />
//         </Route>

//         {/* Catch all → go to login */}
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </Router>
//      <ToastContainer position="bottom-right" />
//     </>
    
    
//   );
// }

// export default App;
